import { API_BASE_URL } from './apiConfig';
import { message } from 'antd';

const apiClient = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;

    const token = sessionStorage.getItem('token');
    const defaultHeaders = {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
    };

    const config = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
    };

    try {
        const response = await fetch(url, config);

        if (!response.ok) {
            const errorText = await response.text();
            let errorMessage = "An error occurred";
            try {
                const errorJson = JSON.parse(errorText);
                errorMessage = errorJson.error || errorMessage;
            } catch (parseError) {
                console.warn("Could not parse error response as JSON:", parseError);
            }
            throw new Error(errorMessage);
        }

        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
            return await response.json();
        } else if (contentType && (
            contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
            contentType.includes("application/octet-stream") ||
            contentType.includes("application/pdf")
        )) {
            return await response.blob();
        }
        return await response.json().catch(() => response.text());

    } catch (error) {
        if (!window.navigator.onLine) {
            message.error("No internet connection.");
        }
        return Promise.reject(error);
    }
};

export default apiClient;